const HamburgerIcon = ({toggleMenu}) => {
  return (
    <>
      {/* <svg
      onClick={toggleMenu}
      className="hamburger-icon nav-icon"
        width="36"
        height="36"
        viewBox="0 0 23 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          
          d="M0 1.275C0 0.936849 0.113588 0.612548 0.315775 0.373439C0.517963 0.13433 0.792188 0 1.07812 0H21.9219C22.2078 0 22.482 0.13433 22.6842 0.373439C22.8864 0.612548 23 0.936849 23 1.275C23 1.61315 22.8864 1.93745 22.6842 2.17656C22.482 2.41567 22.2078 2.55 21.9219 2.55H1.07812C0.792188 2.55 0.517963 2.41567 0.315775 2.17656C0.113588 1.93745 0 1.61315 0 1.275ZM0 8.5C0 8.16185 0.113588 7.83755 0.315775 7.59844C0.517963 7.35933 0.792188 7.225 1.07812 7.225H21.9219C22.2078 7.225 22.482 7.35933 22.6842 7.59844C22.8864 7.83755 23 8.16185 23 8.5C23 8.83815 22.8864 9.16245 22.6842 9.40156C22.482 9.64067 22.2078 9.775 21.9219 9.775H1.07812C0.792188 9.775 0.517963 9.64067 0.315775 9.40156C0.113588 9.16245 0 8.83815 0 8.5ZM1.07812 14.45C0.792188 14.45 0.517963 14.5843 0.315775 14.8234C0.113588 15.0625 0 15.3868 0 15.725C0 16.0632 0.113588 16.3875 0.315775 16.6266C0.517963 16.8657 0.792188 17 1.07812 17H21.9219C22.2078 17 22.482 16.8657 22.6842 16.6266C22.8864 16.3875 23 16.0632 23 15.725C23 15.3868 22.8864 15.0625 22.6842 14.8234C22.482 14.5843 22.2078 14.45 21.9219 14.45H1.07812Z"
          fill="white"
        />
      </svg> */}

      <i onClick={toggleMenu} className="ri-menu-fold-line"></i>
    </>
  );
};

export default HamburgerIcon;
